import log from "loglevel";
import React, { useEffect, useState, useMemo } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { Spinner } from "react-bootstrap";
import displayGlobalMessage from "Utils/DisplayGlobalMessage";
import * as constants from "Constants";
import httpService from "services/httpService.js";
import TableComponent from "./TableComponent";
import { InputText } from "primereact/inputtext";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { useNavigate } from "react-router-dom";
import { Breadcrumb } from "react-bootstrap";

const PlagiarismResultTable = () => {

  log.log("Finally reached!!");

  const location = useLocation();
  const [labTitle, setLabTitle] = useState(location.labTitle);
  const [activityTitle, setActivityTitle] = useState("");
  const { courseId, labId, activityId, plagType } = useParams();
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  const ids = useMemo(() => {
    const value = query.get("ids");
    return value ? value.split(",") : [];
  }, [search]);


  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showMossColumn, setShowMossColumn] = useState(false);
  const [mossPath, setMossPath] = useState("");
  const [lazyLoading, setLazyLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [sortField, setSortField] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const [isNewData, setIsNewData] = useState(true);

   const globalFilterFields = useMemo(
    () => ["student1", "student2", "mossScore", "fettScore"],
    []
  );

  useEffect(() => {
      const fetchLabData = async () => {
        if (labId) {
          var url =
            constants.base_url + "/lab/all/" + labId + `?courseId=${courseId}`;
          try {
            const response = await httpService.get(url);
            setLabTitle(response.data.lab.title);
  
            // Filter the activity with the given program_id and set the activity title
            const activity = response.data.activities.find(
              (activity) => activity.id == activityId
            );
            if (activity) {
              setActivityTitle(activity.name);
            }
          } catch (error) {
            log.error(error);
          }
        }
      };
  
      fetchLabData();
    }, [labId]);

  useEffect(() => {

    if (!(ids && ids.length > 0)) {
        setLoading(false);
        return;
    }

    if (!activityId || !plagType) {
      setLoading(false);
      return;
    }

    const fetchPlagData = async () => {
      setLoading(true);
        try
        {
          var url =
          constants.base_url +
          "/evalpro/get_plagiarism/" +
          activityId +
          "/" +
          plagType +
          "/program"
          const response = await httpService.instance({
            url,
            method: "POST",
            data: { ids: ids },
          })

          log.log(response);
          if (plagType == "moss") {
            const moss_path = response.data.result['moss_path'];
            setMossPath(moss_path);
            log.log("MOSS Path: ",moss_path);
            window.location.href = encodeURI(constants.base_url +"/"+ moss_path);
          } 
          else if (plagType == "fett"){
            const fett_data = response.data.result['data'].map(item => ({
            student1: item["Student 1"] || "",
            student2: item["Student 2"] || "",
            fettScore: item["FETT Score"] ? parseFloat(parseFloat(item["FETT Score"]).toFixed(2)) : null
          }));
            setData(fett_data);
            setShowMossColumn(false);
          } 
          else if (plagType == "combined"){
            const combined_data = response.data.result['data'].map(item => ({
            student1: item["Student 1"] || "",
            student2: item["Student 2"] || "",
            mossScore: item["MOSS Score"] ? parseFloat(parseFloat(item["MOSS Score"]).toFixed(2)) : null,
            fettScore: item["FETT Score"] ? parseFloat(parseFloat(item["FETT Score"]).toFixed(2)) : null
          }));
            setData(combined_data);
            setShowMossColumn(true);
          }
        }
        catch(error){
          log.log(error);
          displayGlobalMessage("Error sending request to server!", "error");
        }
        finally{
        setLoading(false);
      }
    };
    fetchPlagData();
    }, [activityId, plagType, ids]);

  useEffect(() => {

    if (!Array.isArray(data)) {
      setFilteredData([]);
      return;
    }

    let filtered = [...data];

    if (searchQuery) {
    const query = searchQuery.toLowerCase();
    //log.log("Search: ", query);
    filtered = filtered.filter((row) =>
      globalFilterFields.some((field) =>
          String(row[field] || "")
            .toLowerCase()
            .includes(query)
      )
    );
  }

  // Sorting
  if (sortField) {
    filtered.sort((a, b) => {
      const valA = a[sortField];
      const valB = b[sortField];
      if (valA < valB) return sortOrder === 1 ? -1 : 1;
      if (valA > valB) return sortOrder === 1 ? 1 : -1;
      return 0;
    });
  }
  setFilteredData(filtered);
  }, [data, searchQuery, sortField, sortOrder]);

  const handleSearchChange = (e) => {
      setSearchQuery(e.target.value);
    };

    const tableHeader = () => {
      return (
        <div className="flex justify-content-between align-items-center">
          <IconField iconPosition="left">
            <InputIcon className="pi pi-search" />
            <InputText
              value={searchQuery}
              onChange={handleSearchChange}
              placeholder="Search"
            />
          </IconField>
        </div>
      );
    };

  if (loading) return (<div className="h-screen flex justify-content-center align-items-center">
            <Spinner animation="border" />
          </div>);
  
  if (data && data.length !== 0){
    
    const plagTemplate = (rowData, type) => {
    if (!rowData) return "";
    var value;
    if (type === "student1") {
      value = rowData['Student 1'] || null;
    } 
    else if (type === "student2") {
      value = rowData['Student 2'] || null;
    }
    else if (type === "mossScore") {
      value = rowData['MOSS Score'] || null;
    }
    else if (type === "fettScore") {
      value = rowData['FETT Score'] || null;
    }
    else{
      value = null;
    }
    return value;
  };

    const columns = [
    {
      headerStyle: { width: "3rem" },
      header: "S.No.",
      frozen: true,
      body: (data, options) => options.rowIndex + 1,
    },
    {
      field: "student1",
      header: "Student 1",
      frozen: true,
      sortable: true,
      style: { width: "250px" },
      body: (rowData) => rowData.student1
    },
    {
      field: "student2",
      header: "Student 2",
      sortable: true,
      style: { width: "250px" },
      body: (rowData) => rowData.student2
    },
    {
      field: "mossScore",
      header: "MOSS Score",
      sortable: true,
      hidden: !showMossColumn,
      style: { width: "100px" },
      body: (rowData) => rowData.mossScore
    },
    {
      field: "fettScore",
      header: "FETT Score",
      sortable: true,
      style: { width: "100px" },
      body: (rowData) => rowData.fettScore
    }
  ];

  function capitalize(text){
    return text.charAt(0).toUpperCase() + text.slice(1);
  }

    return (

      <div className="cont">
                {/* <Navbar navbarClass="navbar-dark fixed-top" /> */}
                <Breadcrumb style={{ height: '49px', marginBottom: 10, borderBottom: "1px solid grey" }}>
                  <Breadcrumb.Item
                    href={`/courseware/course/${courseId}/content/labs`}
                  >
                    Labs
                  </Breadcrumb.Item>
                  <Breadcrumb.Item
                    href={`/courseware/course/${courseId}/content/labs/${labId}/`}
                  >
                    {labTitle}
                  </Breadcrumb.Item>
                  <Breadcrumb.Item
                    href={`/courseware/course/${courseId}/content/labs/${labId}/programming/${activityId}`}
                  >
                    {activityTitle}
                  </Breadcrumb.Item>
                  <Breadcrumb.Item active>PlagiarismResult</Breadcrumb.Item>
                </Breadcrumb>

        <div className="p-4">
        <h1 align="center" className="text-xl font-bold mb-4">{capitalize(plagType)} Plagiarism Result</h1>
         <hr
            style={{
              height: "1px",
              border: "none",
              backgroundColor: "grey",
            }}
          />

          <TableComponent
            tableData={filteredData}
            columns={columns}
            scrollable={true}
            scrollHeight="600px"
            setTableData={setData}
            tableHeader={tableHeader}
            isNewData={isNewData}
            setIsNewData={setIsNewData}
            lazyLoading={lazyLoading}
            setLazyLoading={setLazyLoading}
            stripedRows={false}
            isInfiniteScroll={true}
            program_id={activityId}
            numberOfRows={100}
            />
        </div>
        </div>
    );
  }
};

export default PlagiarismResultTable;